export const LOGOUT = 'AUTH/LOGOUT'

export const LOGIN_LAWYER = 'AUTH/LOGIN_LAWYER'
export const LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'AUTH/LOGIN_ERROR'
export const REFRESH_SUCCESS = 'AUTH/REFRESH_SUCCESS'

export const DEFAULT_AUTH = 'AUTH/DEFAULT_AUTH'
